// v-notify-on-open: Attach to v-dialog to push a notification when it opens
// Usage:
// <v-dialog v-model="dialog" v-notify-on-open="'Game form opened'">
// <v-dialog v-model="dialog" v-notify-on-open="{ text: 'Saved', type: 'success', once: true }">
export default {
  inserted (el, binding, vnode) {
    el.__notifyPrevOpen = false
    el.__notifyOnceDone = false
  },
  componentUpdated (el, binding, vnode) {
    // Ensure we're on a Vuetify dialog component
    const comp = vnode && vnode.componentInstance
    if (!comp) return
    // v-dialog uses 'value' prop as open state
    const isOpen = !!comp.value
    const prev = !!el.__notifyPrevOpen

    // Only on rising edge (closed -> open)
    if (!prev && isOpen) {
      // Support string or object options
      const opt = typeof binding.value === 'string'
        ? { text: binding.value, type: 'info', once: false }
        : { type: 'info', once: false, ...(binding.value || {}) }

      if (!el.__notifyOnceDone && vnode.context && vnode.context.$notify && opt && opt.text) {
        vnode.context.$notify({ text: opt.text, type: opt.type || 'info' })
        if (opt.once) {
          el.__notifyOnceDone = true
        }
      }
    }

    el.__notifyPrevOpen = isOpen
  },
  unbind (el) {
    delete el.__notifyPrevOpen
    delete el.__notifyOnceDone
  }
}


